export const TEXT_EDITING_EXITED = 'TEXT_EDITING_EXITED';
export const TEXT_SELECTION_CHANGED = 'TEXT_SELECTION_CHANGED';
